<template>
  <div
    class="rounded-circle d-none d-md-flex me-3 my-auto"
    :class="inverse ? 'bg-white' : 'bg-blue-600'"
    style="height:34px; width:34px; min-width:34px"
  >
    <v-loading-animation
      v-if="isLoading"
      color="gray-300"
      width="12"
      height="12"
      class="m-auto"
    />
    <v-icon
      v-else
      :icon="inverse ? 'download-blue-700' : 'download-white'"
      class="cursor-pointer text-white m-auto"
      height="16"
      width="16"
      @click="onDownloadClick"
    />
  </div>
</template>
<script>
import { debounce } from 'lodash-es';
import LoadingAnimation from './LoadingAnimation.vue';

export default {
  components: {
    'v-loading-animation': LoadingAnimation,
  },
  props: {
    action: {
      type: Function,
      default: () => Promise.resolve(),
    },
    inverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      debouncer: { cancel: () => {} },
    };
  },
  methods: {
    onDownloadClick() {
      this.debouncer.cancel();
      this.isLoading = true;
      const toBeCalled = async () => {
        try { await this.action(); } finally { this.isLoading = false; }
      };
      this.debouncer = debounce(
        toBeCalled,
        600,
      );
      this.debouncer();
    },
  },
};
</script>
